var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flex-grid",
    { staticClass: "settings-toggle", attrs: { "align-items": "center" } },
    [
      _c("flex-grid-item", { attrs: { grow: "1" } }, [
        _c("label", { attrs: { for: _vm.name } }, [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _c(
        "flex-grid-item",
        [
          _c("toggle-button", {
            attrs: { labels: true, name: _vm.name, value: _vm.value },
            on: { change: _vm.onChange }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7af1d3eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af1d3eb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/settings-toggle.vue
// module id = 1359
// module chunks = 0